import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Cacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  @Cacheable()
  getLocations() {
    return this.http.get(this.apiUrl + '/v1/locations');
  }

  getNuggetCount(params) {
    return this.http.get(this.apiUrl + '/v1/locations/nuggets-count', { params });
  }

  getNuggetSummary(params) {
    return this.http.get(this.apiUrl + '/v1/locations/nuggets-summary', { params });
  }
}
